

























































































































































































import PrescriptionFormAddress from '@/components/prescription/form/address.vue';
import PrescriptionFormClient from '@/components/prescription/form/client.vue';
import PrescriptionFormInfos from '@/components/prescription/form/infos.vue';
import PrescriptionFormObservation from '@/components/prescription/form/observation.vue';
import PrescriptionFormPatient from '@/components/prescription/form/patient.vue';
import PrescriptionFormSaveArea from '@/components/prescription/form/save-area.vue';
import PrescriptionFormStatusArea from '@/components/prescription/form/status-area.vue';
import TranscriptionOcr from '@/components/prescription/form/transcription-ocr.vue';
import PrescriptionFormUpdateStatus from '@/components/prescription/form/update-status.vue';
import PrescriptionBase from '@/components/prescription/prescription-base.vue';
import PrescriptionFormBase from '@/components/prescription/prescription-form-base.vue';
import PrescriptionProductsList from '@/components/prescription/products-list.vue';
import PrescriptionResumePacient from '@/components/prescription/resume/patient-resume.vue';
import SuccessDialog from '@/components/prescription/success-dialog.vue';
import PrescriptionTypesTabs from '@/components/prescription/types/tabs.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { errorHandling } from '@/helpers/errorHandling';
import { resetModalScroll } from '@/helpers/resetModalScroll';
import StringUtils from '@/helpers/stringUtils';
import { JsonException } from '@/interfaces/base-dto';
import { ID_UNIT_ML_DIA } from '@/interfaces/measurement-unit';
import { BolsaMulticompartException, EnteralPrescricaoDTO, InsumoObrigatorioException, PrescricaoAlterParmDTO, PrescricaoParmDTO, TranscricaoParmDTO } from '@/interfaces/prescription';
import { MedidasProdutosEnteralResult } from '@/interfaces/product';
import { TranscricaoOcrResult } from '@/interfaces/transcricao-ocr';
import DoctorModel from '@/models/doctor-model';
import PatientModel from '@/models/patient-model';
import PrescriptionModel from '@/models/prescription-model';
import * as service from '@/services/prescription';
import {
  ERROR_CODE_CLIENT_UNIT_DISABLED, ERROR_CODE_CONFLICT, ERROR_CODE_HAS_TRANSCRIPTION_IN_PROGRESS, ERROR_CODE_NOT_FOUND, ERROR_CODE_PATIENT_DISABLED, ERROR_CODE_TRANSCRIPTION_IN_PROGRESS
} from '@/settings/consts/api-error';
import {
  MESSAGE_PRESCRIPTION_ERROR, MESSAGE_TRANSCRIPTION_ON_LOAD_ERROR
} from '@/settings/consts/messages';
import { ADMINISTRATION_WAYS_CENTRAL } from '@/settings/consts/prescription-params';
import { PrescriptionValidation } from '@/settings/consts/prescription-validation';
import * as prescriptionsTypes from '@/settings/consts/prescriptions-types';
import * as dialog from '@/subjects/dialog';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { IdNomeDTO } from '../../interfaces/base-dto';
import { TerapiaUsoDTO } from '../../interfaces/therapy';
import PrescriptionFormBagType from './form/bag-type.vue';
import PrescriptionFormEnteral from './form/enteral.vue';
import PrescriptionDraft from './prescription-draft.vue';


@Component({
  components: {
    PermissionAuth,
    PrescriptionFormBase,
    TranscriptionOcr,
    PrescriptionFormClient,
    PrescriptionFormPatient,
    PrescriptionFormBagType,
    PrescriptionFormAddress,
    PrescriptionFormObservation,
    PrescriptionTypesTabs,
    PrescriptionFormInfos,
    PrescriptionProductsList,
    PrescriptionFormSaveArea,
    PrescriptionFormStatusArea,
    PrescriptionFormUpdateStatus,
    PrescriptionResumePacient,
    SuccessDialog,
    PrescriptionFormEnteral,
    PrescriptionDraft
  },
})
export default class PrescriptionForm extends PrescriptionBase {  
  @Prop({
    default: false,
  })
  public isVisualizing: boolean;

  @Prop({default: false})
  public isEdit: boolean;
  
  @Prop({default: false})
  public isToCancel: boolean;

  @Prop()
  public editItem: any;

  @Prop()
  public copyItem: any;

  @Prop()
  public presetDeliveryDates: [];

  @Prop({default: false})
  public deliveryDateDisabled: boolean;

  @Prop({default: false})
  public oneDeliveryDateOnly: boolean;

  @Prop()
  public idReasonAlter: number;

  @Prop()
  public idNotification: any;

  @Prop()
  public linkOrigin: any;

  @Prop()
  public isTranscription: boolean;

  @Prop()
  public draftToLoad: PrescricaoParmDTO;

  public successDialogOpen: boolean = false;
  public item: PrescriptionModel = new PrescriptionModel();
  public terapiaUso:TerapiaUsoDTO = null;

  public ocr:TranscricaoOcrResult = null;
  public file:any = null;
  public typesReady:boolean = false;
  private idPacienteEnteralResult:number = null;
  public enteralResult: MedidasProdutosEnteralResult = null;  

  private isSaveProcess: boolean = false;

  msgSaveResult = null;

  patientHeight:Number = null;
  imc:any = null;

  draft = null;

  openRegisterFormKey = 0;

  get lockFieldsPrescriptionType() {
    return this.item.isLocked();
  }

  get lockBaseInfo() {
    return this.item.isBaseInfoLocked();
  }

  get canShowProducts(): boolean {
    return (
      !!this.item.unidade &&
      !!this.item.unidade.id &&
      !!this.item.medico &&
      !!this.item.medico.id &&
      !!this.item.paciente &&
      !!this.item.paciente.id &&
      !!this.item.dataPrescricao &&
      !!this.item.endereco &&
      !!this.item.endereco.id &&
      !!this.item.tempoInfusao
    );
  }

  @Watch('editItem')
  public onEditItemChanges(val: any) {
    this.resetPrescription();
    this.successDialogOpen = false;
    this.clearForm();
    if (val && val.paciente && val.paciente.imc) {
      this.imc = val.paciente.imc;
      val.paciente.peso = val.paciente.imc.peso;
    }
    this.setItem(val);
  }

  @Watch('draftToLoad', {immediate: true})
  public onChangeDraftToLoad(draftToLoad) {
    if (draftToLoad) {
      this.draft = {... draftToLoad};
    }
  }

  public onUnlockClient(): void {
    if (!this.lockBaseInfo) {
      return;
    }
    this.item.medico = new DoctorModel();
    this.item.paciente = new PatientModel();
    this.onUnlockPatient();
  }

  public onUnlockPatient(): void {
    if (!this.lockBaseInfo) {
      return;
    }
    this.item.endereco = null;
    this.item.registro = null;
    this.item.convenio = null;
    this.item.setor = null;
    this.item.leito = null;
    this.onUnlockTabs();
  }

  public onUnlockTabs(): void {
    if (!this.lockFieldsPrescriptionType) {
      return;
    }
    this.item.divisaoBolsas = 1;
    this.item.volumeDesejado = null;
    this.item.volumeFinalMlKgDia = null;
    this.item.volumeDigitado = null;
    if (this.isTranscription) {
      this.item.viaAdministracao = null;
    } else {
      this.item.viaAdministracao = ADMINISTRATION_WAYS_CENTRAL;
    }
    this.item.tempoInfusao = null;
    this.item.registro = null;
    this.item.copy = false;
    this.item.model = false;
    this.item.profile = false;
    this.item.pattern = false;
    this.item.tipoPrescricao = prescriptionsTypes.DEFAULT;
    this.item.idPrescricaoCopia = null;
    this.item.idTemplate = null;
    this.item.setProducts([]);
    this.item.terapia = null;
    this.patientHeight = null;
    this.resetPrescription();

    setTimeout(() => {
      this.$refs.form.validate();
    }, 500);
  }

  private calcVolumeDesejado(volumeDigitado:number, volumeTotal:number, tipoVolumePorKg:boolean) : number {
    if (!tipoVolumePorKg) {
      return volumeTotal;
    }
    if (volumeDigitado!= null) {
      return volumeDigitado * this.getPesoUsoPaciente();
    }
    return volumeTotal;
  }

  public onUpdateItemModel(item): void {
    this.item.tipoPrescricao = prescriptionsTypes.MODEL;
    this.item.idPrescricaoCopia = item.idPrescricaoCopia;
    this.item.divisaoBolsas = item.divisaoBolsas;
    this.item.viaAdministracao = item.viaAdministracao;
    this.item.volumeDesejado = new String(this.calcVolumeDesejado(item.volumeDigitado, item.volumeDesejado, item.volumeDigitadoPorKg)).toString();
    this.item.volumeDigitadoPorKg = item.volumeDigitadoPorKg;
    this.item.volumeFinalMlKgDia = item.volumeDigitadoPorKg ? item.volumeDigitado : this.item.volumeFinalMlKgDia;
    this.item.tempoInfusao = item.tempoInfusao;
    this.item.registro = item.registro;
    this.item.endereco = item.endereco;
    this.item.setor = item.setor;
    this.item.leito = item.leito;
    this.item.model = true;
    this.item.copy = false;
    this.item.profile = false;
    this.item.pattern = false;
    this.item.setProducts(item.produtos);
    this.receivedProducts = this.item.produtos;
    this.receivedWeight = item.paciente ? item.paciente.peso : null;
    this.receivedCaloricWeight = item.paciente ? item.paciente.pesoCalorico : null;
    this.receivedInfusionTime = item.tempoInfusao;
    this.item.quantidade = item.quantidade;
    (this.item as any).quantidadeCopia = true;
    this.item.bolsaMulticompart = item.bolsaMulticompart;
  }

  public onUpdateItemCopy(item): void {
    this.item.tipoPrescricao = prescriptionsTypes.COPY;
    this.item.idPrescricaoCopia = item.idPrescricaoCopia;
    this.item.divisaoBolsas = item.divisaoBolsas;
    this.item.viaAdministracao = item.viaAdministracao;
    this.item.volumeDesejado = new String(this.calcVolumeDesejado(item.volumeDigitado, item.volumeDesejado, item.volumeDigitadoPorKg)).toString();
    this.item.volumeDigitadoPorKg = item.volumeDigitadoPorKg;
    this.item.volumeFinalMlKgDia = item.volumeDigitadoPorKg ? item.volumeDigitado : this.item.volumeFinalMlKgDia;
    this.item.tempoInfusao = item.tempoInfusao;
    this.item.endereco = item.endereco;    
    (this.item as any).enderecoAtivo = item.enderecoAtivo;
    this.item.setor = item.setor;
    this.item.leito = item.leito;
    this.item.registro = item.registro;
    this.item.model = false;
    this.item.copy = true;
    this.item.profile = false;
    this.item.pattern = false;
    this.item.setProducts(item.produtos);
    this.receivedProducts = this.item.produtos;
    this.receivedWeight = item.paciente ? item.paciente.peso : null;
    this.receivedCaloricWeight = item.paciente ? item.paciente.pesoCalorico : null;
    this.receivedInfusionTime = item.tempoInfusao;
    this.item.quantidade = item.quantidade;
    (this.item as any).quantidadeCopia = true;
    this.item.bolsaMulticompart = item.bolsaMulticompart;
  }

  public onUpdateItemPattern(item): void {
    this.item.tipoPrescricao = prescriptionsTypes.PATTERN;
    this.item.idTemplate = item.idTemplate;
    this.item.volumeDesejado = item.volumeDesejado;
    this.item.tempoInfusao = item.tempoInfusao;
    this.item.model = false;
    this.item.copy = false;
    this.item.profile = false;
    this.item.pattern = true;
    this.item.setProducts(item.produtos);
    this.receivedProducts = this.item.produtos;
    this.receivedWeight = null;
    this.receivedInfusionTime = null;
  }

  /*
  public isTrascription(item: PrescriptionModel): boolean {
    return item.isTranscription();
  }
  */
  
  public onUpdateTherapy(therapy: IdNomeDTO, tnDays: string): void {
    let limpar = this.item.terapia && this.item.terapia.id && !therapy;
    this.onChangeTerapia();
    this.item.terapia = therapy;
    this.item.tnDays = tnDays;
    this.terapiaUso = null;
    if (limpar) {
      setTimeout(() => {
        this.item.volumeDigitado = null;
        this.item.volumeDesejado = null;
        this.item.volumeFinalMlKgDia = null;
        this.imc = null;
        this.patientHeight = null;        
      }, 300);
    }
    if (
      this.item.terapia &&
      this.item.terapia.id &&
      this.item.unidade &&
      this.item.unidade.id &&
      this.item.medico &&
      this.item.medico.id &&
      this.item.paciente &&
      this.item.paciente.id &&
      this.item.paciente.peso
    ) {
      this.loader.start('Processando ...');
      this.addSubsc(
        service
          .getTherapyUsePrescription(
            Number(this.item.terapia.id),
            this.item.unidade.id,
            Number(this.item.medico.id),
            Number(this.item.paciente.id),
            Number(this.item.paciente.peso),
            tnDays
          ).subscribe((res) => {
            this.loader.stop();
            if (res.todosProdutosOk) {
              this.terapiaUso = res;              
              if (res.viaAdministracao){
                this.item.viaAdministracao = res.viaAdministracao;
              }
              setTimeout(() => {
                if (res.volume && res.volume.quantidade) {
                  let vol = Number(res.volume.quantidade);
                  if (res.volume.idUnidadeMedida != ID_UNIT_ML_DIA) {
                    vol *= this.getPesoUsoPaciente();
                    this.item.volumeDigitadoPorKg = true;
                    this.item.volumeFinalMlKgDia = Number(res.volume.quantidade).toString();
                  } else {
                    this.item.volumeDigitadoPorKg = false;
                  }
                  this.item.volumeDesejado =  new String(vol).toString();
                }
              }, 300);
              return;
            }
            let msg = this.item.terapia.nome +' - Sem configuração para o(s) produto(s):<br>';
            this.item.terapia = null;
            msg += '<ul>';
            res.produtos.filter(f=> !f.encontrado).forEach((p) => {
              msg += '<li>' + p.nomeProduto + '</li>';
            });
            msg += '</ul>'
            this.dialog.show(
              'error', 
              'Terapia indisponível para este paciente', 
              null, 
              'Cancelar',
              null, 
              null, 
              null, 
              msg, 
              '550');
          }, (error) => {
            this.loader.stop();
          })
      );
    }
  }

  private getPesoUsoPaciente() {
    return Number(this.item.usoPesoCalorico ?  
        this.item.paciente.pesoCalorico : 
        this.item.paciente.imc && this.item.paciente.imc.pesoIdeal ? 
        this.item.paciente.imc.pesoIdeal : 
        this.item.paciente.peso);
  }

  @Watch('item.unidade')
  onChangeClient(c) {
    if (this.item.isVisualization()) {
      return;
    }
    this.$refs.form.validate();
  }

  @Watch('item.volumeDigitado')
  public onChangeVolumeDigitado(): void {
    if (!this.terapiaUso || !this.terapiaUso.agua) {
      return;      
    }

    setTimeout(() => {
        let vol = this.terapiaUso.agua;
        this.item.volumeDigitadoPorKg = false;
        this.item.volumeDesejado = new String(vol + this.item.volumeDigitado).toString();
    }, 300);
  }

  public onChangeOcr(ocr:TranscricaoOcrResult){  
    this.item.medico = null;
    this.item.paciente = new PatientModel();      
    this.resetPrescription();
    setTimeout(() => {
      this.ocr = ocr;      
    }, 300);
  }

  public onChangeFile(file) {
    this.file = file;
  }

  public onTypesReady(value:boolean) {
    this.typesReady = value;
  }

  public disableTypes(): boolean {
    return false;
  }

  public disableClient(): boolean {
    return !!this.item.isVisualization() || !!this.item.isCopy();
  }

  public disablePatient(): boolean {
    return !!this.item.isVisualization() || !!this.item.isCopy();
  }

  public disableTypesTabs(): boolean {
    return !!this.item.isVisualization();
  }

  public disableAddress(): boolean {
    return !!this.item.isVisualization() || (!!this.item.isCopy() && (this.item as any).enderecoAtivo);
  }

  public disableInfos(): boolean {
    return !!this.item.isVisualization() || !!this.item.isCopy();
  }

  public disableEnteral(): boolean {
    return (
      !!this.item.isVisualization()
    );
  }

  public disableProducts(): boolean {
    return (
      !!this.item.isVisualization() ||
      !!this.item.isCopy() ||
      !!this.item.isPattern()
    );
  }
  
  public disableObservation(): boolean {
    return !!this.item.isVisualization();
  }

  public isPrescricao(): boolean {
    return true;
  }

  public newPrescription() {
    this.$emit('newPrescription');
    this.onEditItemChanges(null);
    resetModalScroll('.input-section form');
  }

  public saveItem(): void {
    
    if(this.isSaveProcess){
      return ;
    }
    this.isSaveProcess = true;

    this.$refs.form.validate();
    if (
      !this.form.valid ||
      (this.item.isVisualization() && !this.item.isEdit()) ||
      !this.item.valid() ||
      !this.flatProducts(this.groupList).length ||
      (this.prescriptionState !== PrescriptionValidation.OK.key &&
        this.prescriptionState !== PrescriptionValidation.ALERT.key)
    ) {
      this.isSaveProcess = false;
      return;
    }

    this.loader.start('Salvando registro...');
    if (!this.item.idPrescricao) {
      let observable;
      if (!this.isTranscription) {
        if (this.alter) {
          let payloadV2 = new PrescricaoAlterParmDTO();
          payloadV2.load(this.item);
          payloadV2.idNotificacaoOrigem = this.idNotification;
          payloadV2.origemLink = this.linkOrigin;
          payloadV2.idAlteracao = this.copyItem.idPrescricao;
          payloadV2.idValorParmMotivo = this.idReasonAlter;
          observable = service.alterPrescriptionV2(payloadV2);  
        } else {
          let payloadV2: PrescricaoParmDTO = new PrescricaoParmDTO();
          payloadV2.load(this.item);
          payloadV2.idNotificacaoOrigem = this.idNotification;
          payloadV2.origemLink = this.linkOrigin;
          payloadV2.uuid = this.uuid;
          observable = service.savePrescriptionV2(payloadV2);
        }
      } else {
        let payloadV2: TranscricaoParmDTO = new TranscricaoParmDTO();
        payloadV2.load(this.item);
        if (this.ocr) {
          payloadV2.ocrKey = this.ocr.key;
        }
        observable = service.saveTranscription(payloadV2, this.file);
      }

      const onError = (error) => {
        this.loader.stop();
        this.isSaveProcess = false;

        if (
          this.isTranscription &&
          error.status === ERROR_CODE_HAS_TRANSCRIPTION_IN_PROGRESS
        ) {
          const unsetTrascriptionProgress = () => {
            this.isSaveProcess = false;
            service
              .unsetTranscriptionProgress(error.data.message)
              .subscribe(() => {
                this.saveItem();
              });
          };

          this.dialog.show(
            'warn',
            'Transcrição em progresso',
            'Você já possui um transcrição em progresso, para criar uma nova é preciso liberar a anterior.',
            'Cancelar',
            '',
            'Liberar',
            () => unsetTrascriptionProgress(),
          );
        } else {
          if (StringUtils.isValidJSONString(error.data.message)) {
            let obj:JsonException = JSON.parse(error.data.message);
            if (obj.className && obj.className == 'BolsaMulticompartException') {
              this.tratarBolsaMulticompartException(obj);
              return;
            }
            if (obj.className && obj.className == 'InsumoObrigatorioException') {
              this.tratarInsumoObrigatorioException(obj);
              return;
            }
          }          

          this.showToastApiError(error);
        }
      };

      observable.subscribe((res) => {
        this.loader.stop();
        this.isSaveProcess = false;
        this.$refs.form.resetValidation();

        if (this.isTranscription) {
          this.emitSave();
        } else {
          this.msgSaveResult = res;
          this.successDialogOpen = true;
        }
        
        this.isSaveProcess = false;

      }, onError);
    }
  }

 
  private tratarBolsaMulticompartException(obj) {
    let bme: BolsaMulticompartException = Object.assign(new BolsaMulticompartException(), obj);
    let messageHtml = "";
    messageHtml += "<ul>";
    if (bme.mensagemAgua) {
      messageHtml += "<li>"
      messageHtml += bme.mensagemAgua
      messageHtml += "</li>";
    }
    if (bme.mensagemNaoAtende) {
      messageHtml += "<li>"
      messageHtml += bme.mensagemNaoAtende;
      messageHtml += "  <ul>";
      bme.produtosNaoAtende.forEach(p => {
        messageHtml += "    <li>" + p + "</li>";
      });
      messageHtml += "  </ul>";
      messageHtml += "</li>";      
    }
    if (bme.compartsAjustar && bme.compartsAjustar.length) {      
      bme.compartsAjustar.forEach(c=>{
        messageHtml += "<li>";
        messageHtml += c.mensagem
        messageHtml += "  <ul>";
        c.produtosAjustar.forEach(p => {
          messageHtml += "    <li>" + p + "</li>";
        });
        messageHtml += "  </ul>";
        messageHtml += "</li>";
      });
    }
    messageHtml += "</ul>";

    dialog.show('error', "Bolsa Multicompartimentada", null, null, null, null, null, messageHtml, "600");
  }

  private tratarInsumoObrigatorioException(obj) {
    let exc: InsumoObrigatorioException = Object.assign(new InsumoObrigatorioException(), obj);
    let msg = "<p>" + exc.mensagem + "</p>"
    msg += "<p>" + exc.explicacao + "</p>"
    dialog.show('warn', exc.titulo, null, 
      "Cancelar", 
      () => {
      }, 
      "Continuar", 
      () => {
        if (!this.item.codInsumosCienteObrig) {
          this.item.codInsumosCienteObrig = [];
        }
        this.item.codInsumosCienteObrig.push(exc.codInsumo);
        this.saveItem();
      }, 
      msg, 
      "600"
    );
  }
  

 /* private checkIsPrescricao(payload): boolean {
    
    return payload.tipoPrescricao == prescriptionsTypes.DEFAULT
      || payload.tipoPrescricao == prescriptionsTypes.PATTERN
      || payload.tipoPrescricao == prescriptionsTypes.COPY
      || payload.tipoPrescricao == prescriptionsTypes.MODEL;
  }*/

  public emitClose() {
    this.clearForm();
    this.$emit('close');
  }
  
  public closeForm(): void {



    const alertPrescription = () => {

      const closeAction = () => {
        this.$refs.form.resetValidation();
        this.emitClose();
      };

      if(!!this.isVisualizing)
        this.emitClose();
      else{
        this.dialog.show(
          'error',
          'Sair sem salvar',
          'Deseja sair sem salvar as alterações?',
          'Cancelar',
          '',
          'Sair',
          closeAction,
        );
      }
    };

    const alertTranscription = () => {
      const closeAction = () => {
        this.loader.start();
        service
          .unsetTranscriptionProgress(this.item.idTranscricao)
          .subscribe(() => {
            this.$refs.form.resetValidation();
            this.loader.stop();
            this.emitClose();
          });
      };

      if(!!this.isVisualizing)
        this.emitClose();
      else{
        this.dialog.show(
          'error',
          'Sair sem salvar',
          'Deseja sair sem salvar as alterações? Ao sair a transcrição será liberada outras transcritoras.',
          'Cancelar',
          '',
          'Sair',
          closeAction,
        );
      }
    };

    if (
      this.isTranscription &&
      !!this.item.idTranscricao &&
      !this.item.isTranscriptionCopy()
    ) {
      alertTranscription();
    } else {
      alertPrescription();
    }
  }

  public clearForm() {
    this.patientHeight = null;
    this.imc = null;
    this.ocr = null; 
    this.file = null;   
  }

  public emitSave() {
    this.clearForm();
    this.$emit('save');
  }

  public closeSuccessDialog() {
    this.successDialogOpen = false;
    this.emitSave();
  }

  public onStatusUpdate(): void {
    this.emitSave();
  }

  private setItem(val: any): void {
    if (
      !val ||
      (!val.idPrescricao && !val.copy && !val.isTranscriptionCopy())
    ) {
      this.item = new PrescriptionModel(val);
      this.item.transcricao = val ? val.transcricao : null;
      return;
    }

    const paciente = {
      ...val.paciente,
      leito: val.leito,
      convenio: val.convenio,
    };

    const unidade = {
      ...val.unidade,
      cliente: val.cliente,
    };

    const editPrescription = {
      ...val,
      paciente,
      unidade,
    };

    if (!!editPrescription.transcricao) {
      editPrescription.idTranscricao = editPrescription.transcricao.id;
    }

    this.item = new PrescriptionModel(editPrescription);
    this.receivedProducts = this.item.produtos.filter(
      (item) => item.disponibilizarNaPrescricao,
    );
    this.receivedWeight = this.item.paciente ? this.item.paciente.peso : null;
    this.receivedInfusionTime = this.item.tempoInfusao;

    if (this.item.isVisualization()) {
      this.validationMessagesFirstTime = false;
    }
  }

  private onChangeEnteral(result: MedidasProdutosEnteralResult) {
    if (this.item.isVisualization()) {
      return;
    }
    this.item.enteral = new EnteralPrescricaoDTO();
    if (result) {
      this.item.enteral.idEnteral = result.idEnteral;  
      this.item.enteral.quantidadeEnteral = result.qtdeEnteralMl;      
      this.setVolumeDesejadoDelay(result.volumeFinal, 1000);
      this.idPacienteEnteralResult = this.item ? this.item.paciente ? Number(this.item.paciente.id) : null : null;
    } else if (this.enteralResult && this.idPacienteEnteralResult && this.item && this.item.paciente && Number(this.item.paciente.id) == this.idPacienteEnteralResult) {
      this.setVolumeDesejadoDelay(this.enteralResult.volumeNP, 1000);
    }
    if (!result) {      
      this.idPacienteEnteralResult = null;
    }
    setTimeout(() => {      
      this.enteralResult = result;  
    }, 500);
  }

  private setVolumeDesejadoDelay(volume:Number, tempo:number) {
    setTimeout(() => {
      if (this.item.volumeDigitadoPorKg) {
        let volKg = Number(volume);
        volKg /= this.getPesoUsoPaciente();
        this.item.volumeFinalMlKgDia = Number(volKg).toString();
      }
      this.item.volumeDesejado =  new String(volume).toString();
    }, tempo);
  }

  public onPrescribeCopy(editable, item) {
    this.closeForm();
    this.$emit('prescribeCopy', editable, item);  
  }

  public onChangePatientHeight(patientHeight){
    this.patientHeight = patientHeight;
    this.item.paciente.altura = patientHeight;    
  }

  public onCalcImc(imc) {
    this.imc = imc;
    this.item.paciente.imc = this.imc;
  }

  public onAlterPrescription(ids, dates, idReason, item) {
    this.closeForm();    
    this.$emit('alterPrescription', ids, dates, idReason, item);
  }

  onLoadDraft(draft: PrescricaoParmDTO) {
    this.draft = draft;
  }

  onInvalidRegisterValue() {
    this.openRegisterFormKey = this.openRegisterFormKey + 1;
  }
}
